import type { TemplateResponse } from 'services/types/message';

/** A single WhatsApp template placeholder value (positional or named). */
export type Parameter = { text: string; type: 'text'; parameter_name?: string };

/** Placeholder values grouped by the template component they belong to. */
export type Parameters = { HEADER: Parameter[]; BODY: Parameter[]; FOOTER: Parameter[]; BUTTON: Parameter[] };

/** A single template from the businessUnit templates response. */
export type Template = TemplateResponse[number];

/** The template rendered with the entered values — what the live preview shows. */
export type FilledMessage = {
  HEADER: string;
  BODY: string;
  FOOTER: string;
  BUTTONS: { text: string; url: string }[];
};

export const getEmptyParameters = (): Parameters => ({ HEADER: [], BODY: [], FOOTER: [], BUTTON: [] });

/** Keys that prefill with the lead/client name. */
export const NAME_PARAM_KEYS = ['client', 'cliente', 'nombre_cliente', 'nombre', 'name'];
/** Keys that prefill with the current executive's name. */
export const USER_PARAM_KEYS = ['user', 'usuario', 'ejecutivo', 'vendedor', 'nombre_vendedor'];
